<template>
  <v-dialog
    v-model="dialog"
    width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="red lighten-2"
        dark
        v-on="on"
        @click="getDataFromApi()"
      >
        Select Active Elements
      </v-btn>
    </template>
    <v-card>
      <v-overlay
        :value="loading"
        :absolute="true"
        color="#fff"
        :opacity="1"
        
      >
        <v-progress-circular 
        indeterminate
        :value="60"
        color="blue-grey"
        >  
        </v-progress-circular>
      </v-overlay>
      <v-card-title
        primary-title
      >
        Please choose your Active Elements 
      </v-card-title>

      <v-card-text>
        <v-card-text>
          <v-chip-group
            multiple
            column
            active-class="primary--text"
            v-model="selectedElements"
          >
            <v-chip v-for="tag in elements" :key="tag.id">
              {{ tag.name }}
            </v-chip>
          </v-chip-group>
        </v-card-text>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn
          color="primary"
          text
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="submit"
          :loading="submitLoading"
          :disabled="submitLoading"

        >
          Submit
        </v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

  import axios from 'axios'
  export default {
    props: ['page', 'device'],
    data(){
      return {
        dialog: false,
        loading: false,
        submitLoading : false,
        elements: [],
        selectedElements: []
      }
    },
    methods: {
      async getDataFromApi(){
        this.selectedElements = [];
        this.loading = true
        const request = {
          type : "management/page",
          action : "getElements",
          data : {
            pageId : this.page.id,
            deviceId: this.device.id
          }
        };
        try {
          const accessToken = await this.$auth.getAccessToken()
          const response = await axios.post('/', JSON.stringify(request),{ headers: {Authorization: `Bearer ${accessToken}`}})
          this.elements = response.data
          for(let i = 0; i < this.elements.length; i++){
            if(this.elements[i].active) { this.selectedElements.push(i);}
          }
          
          this.loading= false
        } catch (e) {
          console.error(e)
          this.loading = false  
        }
      },
      async submit(){
        this.submitLoading = true
        for(let i = 0; i < this.elements.length; i++){
            this.selectedElements.indexOf(i) == -1 ? this.elements[i].active = false : this.elements[i].active = true
          }
        
        
        const request = {
          type : "management/page",
          action: "updateActiveElements",
          data : {
            pageId : this.page.id,
            deviceId : this.device.id,
            elements : this.elements
          }
        }
        
        try {
          const accessToken = await this.$auth.getAccessToken()
          await axios.post('/', JSON.stringify(request),{ headers: {Authorization: `Bearer ${accessToken}`}})
          this.submitLoading = false
          this.dialog = false
          this.$emit('listSubmitted')
        } catch (e) {
          console.error(e)
          this.submitLoading = false
          this.dialog = false
        } 
      }
    }
  }

</script>